
import {Component, Prop, Watch} from 'nuxt-property-decorator';
import BaseFormComponent from '~/components/Form/BaseFormComponent';
import Form from '~/components/Form/Form.vue';
import FormTextarea from '~/components/Form/FormTextarea.vue';
import SaveOrCancel from '~/components/page-components/SaveOrCancel.vue';
import LoadingContext from '~/components/util/LoadingContext.vue';
import {childService} from '~/lib/accessors/api';
import {childGetSingleStore} from '~/lib/accessors/store-accessor';
import ChildView from '~/lib/types/ChildView';
import {toChildView} from '~/store/ChildSearch';


@Component({
  components: {SaveOrCancel, Form, LoadingContext, FormTextarea},
})
export default class ChildDescription extends BaseFormComponent {
  @Prop({
    type: Object,
    required: true,
  })
  child!: ChildView

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  showEdit!: boolean

  editing: boolean = false

  formData = {
    description: ''
  }

  // Truncate text feature
  truncate_text_length = 600
  showing_more: boolean = false

  get is_truncated() {
    return this.child.description.length > this.truncate_text_length;
  }

  get description() {
    const descr = this.child.description;
    if (! this.showing_more && this.is_truncated) {
      return descr.slice(0, this.truncate_text_length) + '...';
    } else {
      return descr;
    }
  }
  // /Truncate text feature

  mounted() {
    this.formData.description = this.child.description;
  }

  @Watch('child', {deep: true})
  watchChild(child: ChildView) {
    this.formData.description = child.description;
  }

  enableEditing () {
    this.formData.description = this.child.description;
    this.editing = true;
  }

  cancel() {
    this.editing = false;
    this.formData.description = this.child.description;
  }

  showMore() {
    this.showing_more = true;
  }

  showLess() {
    this.showing_more = false;
  }

  async send() {
    const [firstName, lastName] = this.child.fullName.split(' ');
    // this.editMode = 'not_editing';
    const childRet              = await childService
        .withContext(this, {
          // onBeforeThrowError: () => this.editMode = 'not_editing',
          emitErrorsTo: this.$refs.errorCatcher,
        })
        .updateChild(this.child.id + '', firstName, lastName, this.formData.description);

    childGetSingleStore.setChild(toChildView(childRet));
    this.editing = false;
    // this.editMode = 'not_editing';
    return true
  }

}
